import { AppProvider } from './providers';
import AppRouter from './routes/AppRouter';

/**
 * Application root.
 * All global providers are composed in AppProvider.
 * The shared route shell (MainLayout) owns the AppBar so header
 * title/navigation stay consistent across the portal.
 */
const App = () => (
  <AppProvider>
    <AppRouter />
  </AppProvider>
);

export default App;
